export function sanitizeRegistrationCode(code: string | undefined) {
  return code
    ?.replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, 12);
}

export function formatRegistrationCode(code: string) {
  const parts = code.match(/.{1,4}/g);
  return (parts ? parts.join(' - ') : code).toUpperCase();
}

export function isValidRegistrationCode(code: string | undefined): boolean {
  return !!code && [4, 8, 12].includes(code.length) && /^[A-Z0-9]+$/.test(code);
}
